import * as React from "react"

function LockerUsageIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2 2v10.667A1.333 1.333 0 003.333 14H14m-9.333-3.333H10M4.667 7.333h8M4.667 4h2"
        stroke="#545454"
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LockerUsageIcon
